import { ChangeDetectionStrategy, Component } from '@angular/core';

/** Decorazioni Halloween dell'header: puramente decorative, nessun impatto sul layout. */
@Component({
    selector: 'app-halloween-header-decor',
    templateUrl: './halloween-header-decor.component.html',
    styleUrl: './halloween-header-decor.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { 'aria-hidden': 'true' }
})
export class HalloweenHeaderDecorComponent {}
